import React, { useState, useRef, useEffect } from 'react';
import Icon from 'components/AppIcon';

const SearchBar = ({ searchQuery, onSearchChange }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const inputRef = useRef(null);

  const searchSuggestions = [
    'mantenimiento semanal',
    'balance químico',
    'temporada lluviosa',
    'control de algas',
    'filtración',
    'ahorro energético',
    'cloro',
    'pH',
    'equipos',
    'limpieza'
  ];

  useEffect(() => {
    if (searchQuery.trim() && searchQuery.length > 2) {
      const filtered = searchSuggestions.filter(suggestion =>
        suggestion.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 5));
    } else {
      setSuggestions([]);
    }
  }, [searchQuery]);

  const handleSuggestionClick = (suggestion) => {
    onSearchChange(suggestion);
    setSuggestions([]);
    inputRef.current?.blur();
  };

  const clearSearch = () => {
    onSearchChange('');
    inputRef.current?.focus();
  };

  return (
    <div className="relative flex-1 max-w-md">
      <div className={`relative flex items-center ${isFocused ? 'ring-2 ring-primary ring-opacity-20' : ''} rounded-lg nav-transition`}>
        <div className="absolute left-3 flex items-center pointer-events-none">
          <Icon name="Search" size={20} className="text-text-secondary" />
        </div>
        
        <input
          ref={inputRef}
          type="text"
          placeholder="Buscar artículos, consejos, guías..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setTimeout(() => setIsFocused(false), 200)}
          className="w-full pl-10 pr-10 py-3 bg-surface border border-border rounded-lg text-text-primary placeholder-text-secondary focus:outline-none focus:border-primary nav-transition"
        />
        
        {searchQuery && (
          <button
            onClick={clearSearch}
            className="absolute right-3 p-1 text-text-secondary hover:text-primary nav-transition"
          >
            <Icon name="X" size={16} />
          </button>
        )}
      </div>

      {/* Search Suggestions */}
      {suggestions.length > 0 && isFocused && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-surface border border-border rounded-lg shadow-large z-50">
          <div className="py-2">
            {suggestions.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => handleSuggestionClick(suggestion)}
                className="w-full px-4 py-2 text-left text-text-primary hover:bg-primary/5 nav-transition flex items-center space-x-2"
              >
                <Icon name="Search" size={14} className="text-text-secondary" />
                <span>{suggestion}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Popular Searches */}
      {!searchQuery && isFocused && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-surface border border-border rounded-lg shadow-large z-50">
          <div className="p-3">
            <p className="text-xs font-medium text-text-secondary mb-2">Búsquedas populares:</p>
            <div className="flex flex-wrap gap-1">
              {searchSuggestions.slice(0, 6).map((suggestion, index) => (
                <button
                  key={index}
                  onClick={() => handleSuggestionClick(suggestion)}
                  className="px-2 py-1 text-xs bg-primary/10 text-primary rounded-md hover:bg-primary/20 nav-transition"
                >
                  {suggestion}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;